export default __webpack_public_path__ + "static/slide09-60c4fbfb8b38abf6c7312ade1cc285ff.png";